import React from 'react';
import './Cavitypet.css';
import cavityImage from '../../../imgs/cavitypetp.webp'; 

const Cavitypet = () => {
  return (
    <div className="Cavity-container">
        <div className='Cavitys'>
             <h2 className="Cavity-title">72 Cavity PET Preforms Injection Molding Production Line</h2>
          <p className="Cavity-date">Sep. 13, 2022</p>

      <div className="Cavity">
        <img src={cavityImage} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
        <div className="Cavity-content">
          
          <p className="Cavity-text">
            After several years of market research, Powerjet launched PET special machine in 2006 and 
            set up PET project department to guide PET customers from standard injection molding machines 
            to PET special injection molding machines, so as to improve the output of the machine & bring 
            practical benefits to customers.
          </p>
        </div>
      </div>
        </div>
                 
    </div>
  );
};

export default Cavitypet;
